var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStakeholders(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 581,
    height: 556,
    viewBox: "0 0 581 556",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_111_5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M387.117 30.6719H30C14.536 30.6719 2 43.2079 2 58.6719V290.176C2 305.64 14.536 318.176 30 318.176H387.117C402.581 318.176 415.117 305.64 415.117 290.176V58.6719C415.117 43.2079 402.581 30.6719 387.117 30.6719Z",
    fill: "white",
    stroke: "#DDE9FF",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3564 92.3421H238.256",
    stroke: "#CAE3F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3564 113.506H238.256",
    stroke: "#CAE3F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3564 134.67H238.256",
    stroke: "#CAE3F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3564 155.831H238.256",
    stroke: "#CAE3F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3564 176.995H238.256",
    stroke: "#CAE3F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.749 77.1411V198.658",
    stroke: "#CAE3F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.423 77.1411L82.4229 198.658",
    stroke: "#CAE3F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.097 77.1411V198.658",
    stroke: "#CAE3F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.768 77.1411V198.658",
    stroke: "#CAE3F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.441 77.1411V198.658",
    stroke: "#CAE3F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.112 77.1411V198.658",
    stroke: "#CAE3F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.786 77.1411V198.658",
    stroke: "#CAE3F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6963 60.7586V198.318H238.937",
    stroke: "#FED489",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.0915 133.525L53.6777 140.327C51.1864 141.119 49.4941 143.432 49.4941 146.046V191.977C49.4941 195.291 52.1804 197.977 55.4941 197.977H217.236C220.55 197.977 223.236 195.291 223.236 191.977V118.984C223.236 115.67 220.55 112.984 217.236 112.984H204.528C202.955 112.984 201.444 112.365 200.322 111.262L186.149 97.3295C183.811 95.0311 180.061 95.035 177.728 97.3383L157.062 117.739C155.939 118.847 154.425 119.469 152.847 119.469H139.678C138.102 119.469 136.589 120.089 135.466 121.196L115.077 141.295C113.954 142.401 112.441 143.021 110.865 143.021H91.8605C90.3022 143.021 88.805 142.415 87.6858 141.331L81.0827 134.934C79.497 133.398 77.1957 132.857 75.0915 133.525Z",
    fill: "url(#paint0_linear_111_5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.4941 141.656L75.0915 133.525C77.1957 132.857 79.497 133.398 81.0827 134.934L87.6858 141.331C88.805 142.415 90.3022 143.021 91.8605 143.021H110.865C112.441 143.021 113.954 142.401 115.077 141.295L135.466 121.196C136.589 120.089 138.102 119.469 139.678 119.469H152.847C154.425 119.469 155.939 118.847 157.062 117.739L177.728 97.3383C180.061 95.035 183.811 95.0311 186.149 97.3295L200.322 111.262C201.444 112.365 202.955 112.984 204.528 112.984H223.236",
    stroke: "#FF4949",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.186 79.1918H267.609V103.768H292.186V79.1918Z",
    fill: "#FFC152"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.707 92.1642L277.851 98.6496L287.409 84.6547",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.186 120.835H267.609V145.411H292.186V120.835Z",
    fill: "#FFC152"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.707 133.807L277.851 140.292L287.409 126.297",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.186 162.478H267.609V187.054H292.186V162.478Z",
    fill: "#FFC152"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.707 175.45L277.851 181.935L287.409 167.94",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.91 86.7011H306.18C305.615 86.7011 305.156 87.1596 305.156 87.7251C305.156 88.2907 305.615 88.7491 306.18 88.7491H379.91C380.475 88.7491 380.934 88.2907 380.934 87.7251C380.934 87.1596 380.475 86.7011 379.91 86.7011Z",
    fill: "#DDE9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.765 94.211H313.006C312.441 94.211 311.982 94.6695 311.982 95.235C311.982 95.8006 312.441 96.259 313.006 96.259H373.765C374.33 96.259 374.789 95.8006 374.789 95.235C374.789 94.6695 374.33 94.211 373.765 94.211Z",
    fill: "#DDE9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.91 128.344H306.18C305.615 128.344 305.156 128.802 305.156 129.368C305.156 129.934 305.615 130.392 306.18 130.392H379.91C380.475 130.392 380.934 129.934 380.934 129.368C380.934 128.802 380.475 128.344 379.91 128.344Z",
    fill: "#DDE9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.765 135.854H313.006C312.441 135.854 311.982 136.312 311.982 136.878C311.982 137.444 312.441 137.902 313.006 137.902H373.765C374.33 137.902 374.789 137.444 374.789 136.878C374.789 136.312 374.33 135.854 373.765 135.854Z",
    fill: "#DDE9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.91 169.987H306.18C305.615 169.987 305.156 170.445 305.156 171.011C305.156 171.577 305.615 172.035 306.18 172.035H379.91C380.475 172.035 380.934 171.577 380.934 171.011C380.934 170.445 380.475 169.987 379.91 169.987Z",
    fill: "#DDE9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.765 177.497H313.006C312.441 177.497 311.982 177.955 311.982 178.521C311.982 179.087 312.441 179.545 313.006 179.545H373.765C374.33 179.545 374.789 179.087 374.789 178.521C374.789 177.955 374.33 177.497 373.765 177.497Z",
    fill: "#DDE9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.742 225.283H44.373V227.331H372.742V225.283Z",
    fill: "#DDE9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.742 237.572H44.373V239.62H372.742V237.572Z",
    fill: "#DDE9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.742 249.86H44.373V251.908H372.742V249.86Z",
    fill: "#DDE9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.742 262.148H44.373V264.196H372.742V262.148Z",
    fill: "#DDE9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.742 274.437H44.373V276.485H372.742V274.437Z",
    fill: "#DDE9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.649 21.8454H48.4721C45.8329 21.8454 43.6934 23.9849 43.6934 26.6241V26.6242C43.6934 29.2634 45.8329 31.4029 48.4721 31.4029H368.649C371.288 31.4029 373.427 29.2634 373.427 26.6241C373.427 23.9849 371.288 21.8454 368.649 21.8454Z",
    fill: "#6985D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.904 31.4032C217.576 31.4032 224.605 24.3734 224.605 15.7016C224.605 7.02985 217.576 0 208.904 0C200.232 0 193.202 7.02985 193.202 15.7016C193.202 24.3734 200.232 31.4032 208.904 31.4032Z",
    fill: "#6985D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.246 14.3377C211.697 14.3377 213.683 12.351 213.683 9.90032C213.683 7.4496 211.697 5.46291 209.246 5.46291C206.795 5.46291 204.809 7.4496 204.809 9.90032C204.809 12.351 206.795 14.3377 209.246 14.3377Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.256 544.042C508.187 529.448 496.314 407.429 491.136 348.243V345.715L492.4 346.437C502.636 348.544 524.443 353.048 529.79 354.204C531.813 361.14 540.025 483.653 543.879 544.042L545.324 555.061H498.18C497.819 552.171 500.348 550.364 503.599 550.364C506.128 548.558 506.128 548.378 514.256 544.042Z",
    fill: "url(#paint1_linear_111_5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513.173 544.766H544.06L545.686 555.062H498.181C498 551.269 501.432 550.366 503.419 550.366C504.43 549.21 510.343 546.151 513.173 544.766Z",
    fill: "#355389"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.875 544.584L456.817 327.11L491.136 345.895C490.956 413.57 490.956 549.136 492.401 550.003C493.846 550.87 493.003 553.615 492.401 554.88H446.16C446.16 552.532 446.702 550.725 452.121 550.003C456.456 549.425 460.43 546.15 461.875 544.584Z",
    fill: "url(#paint2_linear_111_5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.159 544.584H492.046L493.672 554.88H446.167C445.986 551.087 449.418 550.184 451.405 550.184C452.417 549.028 458.329 545.969 461.159 544.584Z",
    fill: "#355389"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.915 311.576C464.766 316.092 496.737 318.621 522.024 314.466L518.051 322.233C518.352 325.786 520.688 333.577 527.624 336.322C528.635 344.125 529.611 351.495 529.972 354.204L492.221 346.437L474.339 337.045L456.638 326.93L455.915 311.576Z",
    fill: "url(#paint3_linear_111_5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.476 157.862C502.154 172.312 489.871 162.739 490.775 154.972L454.83 238.241V257.387C454.649 257.749 453.204 297.306 454.107 310.672C468.196 318.62 505.586 317.355 521.842 314.646L532.499 294.597L533.041 291.345L508.476 157.862Z",
    fill: "url(#paint4_linear_111_5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.122 168.104L494.37 167.91C492.907 168.784 492.337 170.218 491.94 172.017C491.622 173.456 494.719 177.612 496.307 179.511L486.754 269.29L491.136 276.062L493.122 276.101L498.854 269.531L500.641 179.597C502.419 178.006 505.985 174.319 506.026 172.297C506.066 170.274 504.773 168.658 504.122 168.104Z",
    fill: "url(#paint5_linear_111_5)",
    stroke: "#FB9500"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.125 220.54C357.582 223.864 366.504 226.019 370.659 226.681C371.201 223.069 372.248 215.23 372.104 212.773C371.959 210.317 367.227 208.378 364.879 207.715C362.109 210.726 356.281 217.505 355.125 220.54Z",
    fill: "#FFAF78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.769 202.839C372.393 204.717 380.293 214.941 383.664 219.818C382.942 224.442 377.703 227.043 375.174 227.765L371.02 226.862C370.779 226.2 370.189 224.225 369.755 221.624C369.214 218.372 370.659 215.482 371.02 213.676C371.381 211.87 367.769 209.522 365.782 208.98C363.794 208.438 365.782 211.689 367.769 213.676C369.757 215.663 367.769 216.024 365.782 215.482C363.794 214.94 361.266 211.689 360.905 213.676C360.543 215.663 363.975 216.747 364.337 217.65C364.699 218.553 365.962 219.095 363.975 219.456C361.988 219.817 358.738 216.385 358.195 217.65C357.653 218.914 361.808 220.54 363.072 221.624C364.084 222.491 362.651 222.707 361.808 222.707C359.942 222.226 355.956 220.973 354.945 219.818C353.68 218.373 353.319 216.024 356.209 215.482C355.667 213.315 355.486 211.689 359.641 211.689C358.34 206.921 362.23 206.21 364.337 206.451C362.892 205.066 359.243 201.357 356.209 197.601C354.186 193.121 357.052 193.567 358.738 194.349C360.303 195.794 364.301 199.515 367.769 202.839Z",
    fill: "#FFAF78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552.911 172.132C547.42 166.497 520.584 157.673 508 154C506.554 156.709 524.372 246.31 533.042 291.346L542.796 235.713L546.789 251.58C548.635 258.913 547.645 266.664 544.021 273.301C534.001 291.651 520.201 317.092 518.049 322.233C518.338 329.458 523.649 334.877 527.624 336.502C542.134 325.906 572.997 296.62 580.367 264.252C581.992 219.637 559.775 179.177 552.911 172.132Z",
    fill: "url(#paint6_linear_111_5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.608 241.856C428.423 185.5 470.846 160.213 490.956 154.613L454.831 238.604V257.39C448.617 268.083 442.849 272.442 440.742 273.285H430.628C413.107 269.492 384.025 240.591 372.646 228.309C380.738 227.008 383.604 221.987 384.025 219.639C391.792 224.395 409.782 235.498 419.608 241.856Z",
    fill: "url(#paint7_linear_111_5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.476 157.863L506.851 137.452C499.771 155.37 493.243 153.708 490.955 150.457C490.955 152.564 490.414 156.598 490.955 159.127C491.678 161.656 493.845 166.352 500.167 166.352C506.309 164.907 508.476 159.007 508.476 157.863Z",
    fill: "#FFB27F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.883 122.647C516.75 111.521 511.006 109.335 507.935 109.998C506.309 113.068 502.263 120.805 500.529 123.55C503.781 123.37 504.684 127.705 504.684 129.692C511.186 128.427 509.5 133.786 507.754 136.555C508.718 136.134 511.837 132.762 515.883 122.647Z",
    fill: "url(#paint8_linear_111_5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.105 131.853C483.911 133.298 486.259 132.576 486.259 132.576C491.317 131.853 496.916 126.434 497.819 124.989C498.542 124.122 499.927 123.665 500.529 123.544C501.552 121.979 504.466 116.933 507.934 109.997C505.189 104.65 498.722 103.795 495.832 104.036C492.882 104.096 486.187 106.276 483.008 114.513C469.28 114.079 476.686 121.316 482.105 124.989C482.105 124.989 479.956 130.25 482.105 131.853Z",
    fill: "url(#paint9_linear_111_5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.852 137.452C494.714 167.075 486.862 146.664 484.454 132.756C492.582 132.213 498.182 124.447 498.182 124.447C501.794 121.738 504.684 124.989 504.684 129.685C512.451 127.698 509.019 136.368 506.852 137.452Z",
    fill: "#FFB27F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.956 150.459C493.425 156.901 499.626 163.97 505.406 140.705C499.626 152.987 495.11 154.794 490.956 150.459Z",
    fill: "#F3A36A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.87 321.693C517.148 324.944 520.037 333.433 527.624 336.865",
    stroke: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_111_5",
    x1: 136.536,
    y1: 70.3162,
    x2: 136.365,
    y2: 197.977,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1BF57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFBF57",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_111_5",
    x1: 504.934,
    y1: 313.558,
    x2: 594.688,
    y2: 335.479,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#398B79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2DA58A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_111_5",
    x1: 458.137,
    y1: 292.123,
    x2: 537.676,
    y2: 307.622,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#398B79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2DA58A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_111_5",
    x1: 474.772,
    y1: 305.029,
    x2: 510.026,
    y2: 362.817,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#398B79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2DA58A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_111_5",
    x1: 496.955,
    y1: 155.514,
    x2: 496.955,
    y2: 316.279,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0047FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_111_5",
    x1: 497.44,
    y1: 167.971,
    x2: 495.289,
    y2: 276.145,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEC778"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB344"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_111_5",
    x1: 547.657,
    y1: 154.07,
    x2: 547.657,
    y2: 336.502,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0047FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_111_5",
    x1: 437.217,
    y1: 154.613,
    x2: 437.217,
    y2: 273.285,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0047FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_111_5",
    x1: 503.058,
    y1: 112.887,
    x2: 513.354,
    y2: 135.646,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D1A64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#30157B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_111_5",
    x1: 480.545,
    y1: 107.203,
    x2: 486.892,
    y2: 135.051,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D1A64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#30157B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_111_5"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 581,
    height: 556,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStakeholders);
export default __webpack_public_path__ + "static/media/stakeholders.e87967b39f3b5df3828a08c36532c4e1.svg";
export { ForwardRef as ReactComponent };